import React from 'react';
// import DashboardLayout from '../components/Layouts/DashboardLayout';
import DashboardSidebar from '../components/DashboardComponents/DashboardSidebar';
import InnerBanner from '../components/PagesComponents/InnerBanner';
import AdminEnquiryInfoList from '../components/AdminComponents/AdminEnquiryInfoList';
const AdminEnquiry = () => {
 return (
    <>
{/* <InnerBanner pageKey="buyerDashboard" /> */}

      <section className='admin-enquery-sec py-4'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-12'>
                   <AdminEnquiryInfoList/> 
                </div>
               
            </div>
        </div>
      </section>
    </>
 );

};

export default AdminEnquiry;